import { SearchFilterEnum } from "types/enums";

export const normalizeValuelessFilterOperators = (
    filters: Record<string, unknown>
): Record<string, unknown> =>
    Object.fromEntries(
        Object.entries(filters).map(([field, operators]) => {
            if (typeof operators !== "object" || operators === null || Array.isArray(operators)) {
                return [field, operators];
            }

            return [
                field,
                Object.fromEntries(
                    Object.entries(operators).map(([operator, value]) => [
                        operator,
                        operator === SearchFilterEnum.Null || operator === SearchFilterEnum.NotNull ? 1 : value,
                    ])
                ),
            ];
        })
    );
